import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input
} from '@angular/core'
import { BrnAvatar } from '@spartan-ng/brain/avatar'
import { hlm } from '@spartan-ng/helm/utils'
import type { ClassValue } from 'clsx'

@Component({
  selector: 'hlm-avatar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': '_computedClass()'
  },
  template: `
    @if (_image()?.canShow()) {
    <ng-content select="[hlmAvatarImage],[brnAvatarImage]" />
    } @else {
    <ng-content select="[hlmAvatarFallback],[brnAvatarFallback]" />
    }
  `
})
export class HlmAvatar extends BrnAvatar {
  public readonly userClass = input<ClassValue>('', { alias: 'class' })

  protected readonly _computedClass = computed(() =>
    hlm(
      'relative flex size-8 shrink-0 overflow-hidden rounded-full',
      this.userClass()
    )
  )
}
